<template>
    <div id="clock-container">
        <div id="clock">
            <p class="time">{{ currentTime }}</p>
            <p class="date">{{ currentDate }}</p>
        </div>
    </div>
</template>

<script>
export default {
    
  name: 'Clock',
  data: () => ({
      currentDate: null,
      currentTime: null
  }),
  methods: {
      getDateTime() {
        var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        var week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        //var timerID = setInterval(updateTime, 1000);

        var cd = new Date();
        var ct =  cd.toLocaleTimeString('en-US', { hour12: true,hour: '2-digit', minute:'2-digit' });
        this.currentTime = ct.replace("AM","").replace("PM","")
        //this.currentTime = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2);
        this.currentDate = week[cd.getDay()] + ', ' + month[cd.getMonth()] + ' ' + zeroPadding(cd.getDate(), 2);

        function zeroPadding(num, digit) {
            var zero = '';
            for(var i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit)
        }

      }
  },
  created() {
      this.getDateTime()
  },
  mounted() {
    this.interval = setInterval(() => this.getDateTime(), 10000)
  }
}
</script>

<style lang="scss" scoped>
    #clock-container {
       #clock {
           color: #fff;
           line-height: 1.1;
           font-weight: 300;

           p {
               text-shadow: 1px 1px 2px rgba(0,0,0,.1), -1px -1px 2px rgba(0,0,0,.1), -1px 1px 2px rgba(0,0,0,.1), 1px -1px 2px rgba(0,0,0,.1);
           }
           
           .time {
               font-size: 50px;
               margin-bottom: 8px;
           }
           .date {
               font-size: 20px;
           }
       } 
    }
</style>
